"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
function BlogGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="flex flex-col gap-4 animate-pulse">
            <div className="w-full aspect-video bg-muted rounded-lg" />
            <div className="h-6 w-3/4 bg-muted rounded" />
            <div className="h-4 w-24 bg-muted rounded mt-2" />
          </div>)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-muted-foreground py-12">
        <p>ブログ記事の読み込み中にエラーが発生しました。</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="text-center text-muted-foreground py-12">
        <p>現在、表示できるブログ記事はありません。</p>
      </div>;
  }
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="flex flex-col bg-background rounded-lg overflow-hidden">
          <Link to={post.link || "#"} className="block" aria-hidden="true" tabIndex={-1}>
            <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628443/img/counseling_blog_thumb.png"} loading="lazy" alt="" className="w-full aspect-video object-cover" />
          </Link>
          <div className="flex flex-col flex-grow p-6">
            <Link to={post.link || "#"} className="block mb-3">
              <h3 className="text-lg font-default font-bold text-foreground leading-snug hover:text-primary-heading transition-colors line-clamp-3">{post.title}</h3>
            </Link>
            <div className="mt-auto pt-2">
              {post.date ? <time dateTime={post.date} className="text-sm text-muted-foreground">{new Date(post.date).toLocaleDateString("ja-JP", {
              year: "numeric",
              month: "long",
              day: "numeric"
            })}</time> : null}
            </div>
          </div>
        </article>)}
    </div>;
}
export default function LatestBlog() {
  return <section data-section-id="223439" id="blog" className="bg-secondary/30 py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">
        <div className="mb-12">
          <span className="inline-block w-fit bg-primary text-primary-foreground text-sm font-bold px-3 py-1 rounded-sm mb-4">ブログ</span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">最新のブログ</h2>
          <Separator className="w-12 h-0.5 bg-primary mb-8" />
          <p className="text-foreground leading-relaxed font-default">心の健康や日々の気づき、カウンセリングに関する役立つ情報を定期的にお届けしています。</p>
        </div>

        <PostsProvider wp_query={{
        post_type: "post",
        per_page: 3,
        orderby: "date",
        order: "desc"
      }}>
          <BlogGridConsumer />
        </PostsProvider>

        <div className="pt-12 flex justify-center">
          <Button asChild variant="outline" size="lg" className="border-primary text-primary-heading hover:bg-primary/10 px-8 rounded-lg">
            <Link to="https://yotsuya-sc-room.com/blog/">ブログ記事一覧を見る</Link>
          </Button>
        </div>
      </div>
    </section>;
}